import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldAlert, FileCheck, Stethoscope, Clock4, Users, BoxIcon } from 'lucide-react';
export const WhyUs = () => {
  const points = [{
    icon: ShieldAlert,
    title: 'Повна анонімність',
    desc: 'Без постановки на облік. Ваші дані суворо конфіденційні.'
  }, {
    icon: FileCheck,
    title: 'Ліцензована клініка',
    desc: 'Офіційна медична ліцензія МОЗ України. Сертифіковані препарати.'
  }, {
    icon: Stethoscope,
    title: 'Досвідчені лікарі',
    desc: 'В штаті працюють наркологи-реаніматологи вищої категорії.'
  }, {
    icon: Clock4,
    title: 'Цілодобовий виїзд',
    desc: 'Чергові бригади готові до виїзду 24/7 без вихідних та свят.'
  }, {
    icon: BoxIcon,
    title: 'Сучасне обладнання',
    desc: 'Використовуємо передове обладнання для моніторингу та реанімації.'
  }, {
    icon: Users,
    title: 'Індивідуальний підхід',
    desc: "Складаємо план лікування враховуючи вік, стаж та стан здоров'я."
  }];
  return <section className="py-24 bg-white" data-id="element-263">
      <div className="container mx-auto px-4 md:px-6" data-id="element-264">
        <div className="flex flex-col lg:flex-row gap-16" data-id="element-265">
          <div className="lg:w-1/3" data-id="element-266">
            <FadeIn data-id="element-267">
              <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-268">
                Чому обирають нас
              </h2>
              <p className="text-gray-600 mb-12" data-id="element-269">
                Ми гарантуємо професійний підхід, безпеку та повну
                конфіденційність на кожному етапі лікування.
              </p>

              <div className="grid grid-cols-2 gap-8 border-t border-gray-200 pt-8" data-id="element-270">
                <div data-id="element-271">
                  <div className="text-4xl font-display font-bold mb-1" data-id="element-272">
                    15+
                  </div>
                  <div className="text-sm text-gray-500 uppercase tracking-wide" data-id="element-273">
                    Років досвіду
                  </div>
                </div>
                <div data-id="element-274">
                  <div className="text-4xl font-display font-bold mb-1" data-id="element-275">
                    10k+
                  </div>
                  <div className="text-sm text-gray-500 uppercase tracking-wide" data-id="element-276">
                    Врятованих життів
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>

          <div className="lg:w-2/3" data-id="element-277">
            <div className="grid sm:grid-cols-2 gap-x-8 gap-y-12" data-id="element-278">
              {points.map((point, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-279">
                  <div className="flex gap-4" data-id="element-280">
                    <div className="flex-shrink-0 mt-1" data-id="element-281">
                      <point.icon className="w-6 h-6 text-gray-400" strokeWidth={1.5} data-id="element-282" />
                    </div>
                    <div data-id="element-283">
                      <h4 className="text-lg font-bold mb-2" data-id="element-284">{point.title}</h4>
                      <p className="text-gray-600 text-sm leading-relaxed" data-id="element-285">
                        {point.desc}
                      </p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};